import { compareNaturalText } from "@/lib/compare-natural-text";
import { Row } from "@tanstack/react-table";

import { isRawRow, TSectionData } from "../datatable-types";

export const sortRowsByTitle = <TData extends { title: string }>(
  rowA: Row<TSectionData<TData>>,
  rowB: Row<TSectionData<TData>>,
): number => {
  if (!isRawRow(rowA.original) || !isRawRow(rowB.original)) {
    return 0;
  }

  return compareNaturalText(rowA.original.title, rowB.original.title);
};
